import { render } from "./App.vue?vue&type=template&id=83035bd6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=83035bd6&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-geoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__